import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigurationService, DashboardContext, DashboardDialogService, DialogService, HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';
import { Transport } from 'src/tmc-yard/common/model/transport.model';
import { TransportAttachDetachDialogComponent } from 'src/tmc-yard/components/attach-detach/component/transport-attach-detach-dialog.component';
import { AttachDetachDetails } from 'src/tmc-yard/components/attach-detach/model/attach-detach-details';

@Component({
  selector: 'app-attach-detach-transport-dialog-action',
  templateUrl: './attach-detach-transport-dialog-action.component.html',
  styleUrls: ['./attach-detach-transport-dialog-action.component.scss']
})
export class AttachDetachTransportDialogActionComponent {

  @Input() disabled = false;

  @Input() transport: Transport;

  @Input() asButton = false;

  @Output() onChange = new EventEmitter();

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private configurationService: ConfigurationService,
    private httpClient: HttpService
  ) { }

  clickButton() {

    this.httpClient.postWithContext<AttachDetachDetails>(environment.attachDetachEndpoint + '/details', { id: this.transport.id })
      .subscribe(
        result => {
          this.dialogService.openMiddle(TransportAttachDetachDialogComponent, { details: result }).afterClosed().subscribe(() => {
            this.onChange.next();
          });
        }, error => {
          console.log('Error loading AttachDetachDetails', error);
        });

  }
}

